module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_5.1af8f5bd.png";